// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-cart {
  padding: 50px 20px;
}
.empty-cart i {
  font-size: 60px;
  color: #999;
}
.empty-cart h3 {
  font-weight: 600;
  color: #333;
}
.empty-cart p {
  font-size: 15px;
}

::ng-deep .p-button.p-fileupload-choose {
  background-image: linear-gradient(to right, #FF4D8D 0%, #507EFB 50%, #FF4D8D 100%) !important;
  background-size: 200% 200%;
  border: none !important;
  color: #fff !important;
  box-shadow: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/app/product-order/product-order.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,eAAA;EACA,WAAA;AACR;AAEI;EACI,gBAAA;EACA,WAAA;AAAR;AAGI;EACI,eAAA;AADR;;AAKA;EACI,6FAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;AAFJ","sourcesContent":[".empty-cart {\n    padding: 50px 20px;\n\n    i {\n        font-size: 60px;\n        color: #999;\n    }\n\n    h3 {\n        font-weight: 600;\n        color: #333;\n    }\n\n    p {\n        font-size: 15px;\n    }\n}\n\n::ng-deep .p-button.p-fileupload-choose {\n    background-image: linear-gradient(to right, #FF4D8D 0%, #507EFB 50%, #FF4D8D 100%) !important;\n    background-size: 200% 200%;\n    border: none !important;\n    color: #fff !important;\n    box-shadow: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
